import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoListItemNewFooterContainer } from "./TodoListItemFooterContainer";
import { Box, useLayoutContext } from "arkh";
import { TodoListItemFooterItem } from "./TodoListItemFooterItem";
import { TodoListItemContact } from "./TodoListItemContact";
import { TodoListItemFooterDone_todo$key } from "./__generated__/TodoListItemFooterDone_todo.graphql";

export function TodoListItemFooterDone(props: {
  todo: TodoListItemFooterDone_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemFooterDone_todo on Todo {
        ...TodoListItemContact_todo
        feedbackStatus
        contact {
          __typename
        }
      }
    `,
    props.todo
  );

  const hasContact = todo.contact !== null;

  const layout = useLayoutContext();

  const items = [];

  if (hasContact && todo.feedbackStatus) {
    items.push(<TodoListItemContact todo={todo} expanded />);
  }

  if (items.length === 0) {
    return <Box spaceBottom="medium" />;
  }

  return (
    <Box
      style={{
        marginRight: -layout.space.medium,
        marginBottom: -layout.space.xsmall,
      }}
    >
      <TodoListItemNewFooterContainer>
        {items.map((item, i) => (
          <TodoListItemFooterItem key={i} isFirst={i === 0}>
            {item}
          </TodoListItemFooterItem>
        ))}
      </TodoListItemNewFooterContainer>
    </Box>
  );
}
